<div class="row">
  <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
    <h3>{{ "i18n.base.forgot-password.header" | translate }}</h3>
    @if (!forgotPasswordSuccess) {
      <form [formGroup]="forgotPasswordForm">
        <p>{{ "i18n.base.forgot-password.info" | translate }}</p>
        <div class="form-group">
          <label for="userName">{{ "i18n.base.forgot-password.userName" | translate }}</label>
          <input id="userName" class="form-control" formControlName="userName" appRequired>
          <app-error-messages [control]="formFields.userName"></app-error-messages>
        </div>
        <button type="submit" class="btn btn-primary me-2" (click)="formSubmit()" [disabled]="!forgotPasswordForm.valid">
          {{ "i18n.base.forgot-password.submit-button" | translate }}
        </button>
        <a type="button" class="btn btn-outline-secondary" [routerLink]="loginRoute">
          {{ "i18n.base.forgot-password.back-button" | translate }}
        </a>
      </form>
    }
    @if (forgotPasswordSuccess) {
      <div>
        <p class="success-message"><span class="e-icons icon-checkmark me-1"></span>{{ "i18n.base.forgot-password.success-info" | translate }}</p>
      </div>
    }
  </div>
</div>
